import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "@/services/axiosAuth";
import { JOURNAL_ENTRY } from "./apiRoutes";

const mutateAddJournalEntry = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(
    `${JOURNAL_ENTRY}?communityId=${data?.communityId}`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};  

const useAddJournalEntryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddJournalEntry,
    ...queryParams,
  });

export default useAddJournalEntryMutation;
